import { render } from "./LeftSidebar.vue?vue&type=template&id=298d4f27"
import script from "./LeftSidebar.vue?vue&type=script&lang=js"
export * from "./LeftSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__